import useAxiosInterceptor from '../interceptor';
import { apiPath } from './constants';
import { keycloakAuthUrl } from 'src/config';
import axios from 'axios';
import tokenManagementService from '../tokenManagementService/tokenService';
import { secretKey } from 'src/config';
import {
  therapistToken,
  tokenType,
} from '../tokenManagementService/constant';

const formatDataToUrlEncoded = (data: any) => {
  const urlEncodedData = new URLSearchParams();
  for (const key in data) {
    urlEncodedData.append(key, data[key]);
  }
  return urlEncodedData.toString();
};

const getToken = () => {
  return tokenManagementService.getToken(therapistToken, secretKey);
};

class AuthService {

  private axiosInstance;

  constructor() {
    this.axiosInstance = this.setupAxiosInstance();
  }

  private setupAxiosInstance() {
    const axiosInstance = useAxiosInterceptor();
    return axiosInstance;
  }

  therapistLogin = (payload: object, subdomain: string) => {
    const data = formatDataToUrlEncoded(payload);

    const config = {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    };

    return axios.post(
      `${keycloakAuthUrl}/${subdomain}/protocol/openid-connect/token`,
      data,
      config
    );
  };

  logout = (payload: object, subdomain: string) => {
    const data = formatDataToUrlEncoded(payload);
    const config = {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'Authorization': `${tokenType} ${getToken()}`,
      },
    };

    return axios.post(
      `${keycloakAuthUrl}/${subdomain}/protocol/openid-connect/logout`,
      data,
      config
    );
  };

  setPassword = (payload: any) => {
    if (payload.self) {
      const requestData = {
        oldPassword: payload.oldPassword,
        newPassword: payload.newPassword,
      };
      return this.axiosInstance.post(apiPath.SELF_RESET_PASSWORD_THERAPIST_ROLE, requestData, {
        headers: {
          Authorization: `Bearer ${payload.token}`,
        },
      });
    } else {
      return this.axiosInstance.post(apiPath.SET_PASSWORD, payload);
    }
  };

  verifyEmailLink = (data: object) => {
    return this.axiosInstance.get(apiPath.VERIFY_VERIFICATION_LINK, {
      params: { ...data },
    });
  };
  getGeneratedPassword = () => {
    return this.axiosInstance.get(`${apiPath.GENERATE_PASSWORD}`);
  };

  getPostTherapistResetPassword = (payload: object) => {
    return this.axiosInstance.post(`${apiPath.POST_RESET_PASSWORD_THERAPIST}`, payload);
  };
}

const authService = new AuthService();

Object.freeze(authService);

export default authService;
